import 'dayjs/locale/sk'

import dayjs from 'dayjs'
import pluginRelativeTime from 'dayjs/plugin/relativeTime'

dayjs.locale('sk')
dayjs.extend(pluginRelativeTime)

export default dayjs
